import type { ChiliPiperMeeting } from '@transcend-io/contact-form-schema';

function asRecord(value: unknown): Record<string, unknown> | undefined {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return value as Record<string, unknown>;
  }
  return undefined;
}

function asString(value: unknown): string | undefined {
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

export function mergeChiliPiperMeetings(
  current: ChiliPiperMeeting | null | undefined,
  incoming: ChiliPiperMeeting | null | undefined,
): ChiliPiperMeeting | null {
  if (!incoming) {
    return current ?? null;
  }
  if (!current) {
    return incoming;
  }
  return {
    eventId: incoming.eventId ?? current.eventId,
    assignee: incoming.assignee ?? current.assignee,
    assigneeEmail: incoming.assigneeEmail ?? current.assigneeEmail,
  };
}

/**
 * Pull `eventId`, Salesforce assignee id, and assignee email from Concierge
 * `onSuccess` / postMessage payloads.
 *
 * @see https://help.chilipiper.com/hc/en-us/articles/1500011381522
 */
export function parseChiliPiperMeeting(
  data: unknown,
): ChiliPiperMeeting | null {
  const root = asRecord(data);
  if (!root) {
    return null;
  }

  const args = asRecord(root.args) ?? root;
  const eventId = asString(args.eventId ?? args.event_id);
  const assignee = asString(args.assigneeId ?? args.assignee_id);
  const assigneeEmail = asString(
    args.assigneeEmail ??
      args.assignee_email ??
      args.hostEmail ??
      args.host_email,
  );

  if (!eventId) {
    return null;
  }

  return {
    eventId,
    ...(assignee ? { assignee } : {}),
    ...(assigneeEmail ? { assigneeEmail } : {}),
  };
}
